document.addEventListener('DOMContentLoaded', function() {
    const buttons = document.querySelectorAll('.button:not(.slideshow-control), a.button, .button-secondary, .product-button, .tab-button');
    
    buttons.forEach(button => {
        button.classList.add('button-watered')
        const buttonContent = button.innerHTML
        button.innerHTML = '<span class="button-content">'+buttonContent+'</span>'


        const water = `<svg version="1.1" id="logo" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 300 300" preserveAspectRatio="none" width="100%" height="100%">
              <path class="fill waveShape" fill="#04ACFF" d="M300,300V2.5c0,0-0.6-0.1-1.1-0.1c0,0-25.5-2.3-40.5-2.4c-15,0-40.6,2.4-40.6,2.4
    c-12.3,1.1-30.3,1.8-31.9,1.9c-2-0.1-19.7-0.8-32-1.9c0,0-25.8-2.3-40.8-2.4c-15,0-40.8,2.4-40.8,2.4c-12.3,1.1-30.4,1.8-32,1.9
    c-2-0.1-20-0.8-32.2-1.9c0,0-3.1-0.3-8.1-0.7V300H300z" />
        </svg>`;
        const waterContainer = document.createElement('div');
        waterContainer.className = 'water-svg';
        
        waterContainer.innerHTML = water;
        button.appendChild(waterContainer);
    });
});